import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import {Link} from "react-router-dom";

// const pages = ['Поиск изображения', 'Добавление изображения'];

const ResponsiveAppBar = () => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        console.log(event)
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = (e) => {
        setAnchorElNav(e.value);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <AppBar position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    {/*<AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />*/}

                    <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: {xs: 'block', md: 'none'},
                            }}
                        >
                            <MenuItem key="Поиск по изображению">
                                <Typography textAlign="center"> <Link to="/">Поиск по изображению</Link></Typography>
                            </MenuItem>
                            <MenuItem key="Поиск по видео">
                                <Typography textAlign="center"> <Link to="/video_search">Поиск по видео</Link></Typography>
                            </MenuItem>
                            {/*  <MenuItem key="Добавление изображения">*/}
                            {/*      <Typography textAlign="center"> <Link to="/load">Добавление изображения</Link></Typography>*/}
                            {/*    </MenuItem>*/}
                            <MenuItem key="Добавление изображений">
                                <Typography textAlign="center"> <Link to="/load_images">Добавление
                                    изображений</Link></Typography>
                            </MenuItem>

                        </Menu>
                    </Box>
                    <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
                        <Button
                            key="Поиск по изображению"

                            sx={{my: 2, color: 'white', display: 'block'}}
                        >
                            <Link style={{color: 'inherit', textDecoration: 'inherit'}} to="/">Поиск по изображению</Link>
                        </Button>

                                                <Button
                            key="Поиск по видео"

                            sx={{my: 2, color: 'white', display: 'block'}}
                        >
                            <Link style={{color: 'inherit', textDecoration: 'inherit'}} to="/video_search">Поиск по видео</Link>
                        </Button>

                        <Button
                            key="Добавление изображений"

                            sx={{my: 2, color: 'white', display: 'block'}}
                        >
                            <Link style={{color: 'inherit', textDecoration: 'inherit'}} to="/load_images">Добавление
                                изображений</Link>
                        </Button>

                    </Box>

                    {/*<Box sx={{ flexGrow: 0 }}>*/}
                    {/*  <Tooltip title="Open settings">*/}
                    {/*    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>*/}
                    {/*      <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />*/}
                    {/*    </IconButton>*/}
                    {/*  </Tooltip>*/}
                    {/*  <Menu*/}
                    {/*    sx={{ mt: '45px' }}*/}
                    {/*    id="menu-appbar"*/}
                    {/*    anchorEl={anchorElUser}*/}
                    {/*    anchorOrigin={{*/}
                    {/*      vertical: 'top',*/}
                    {/*      horizontal: 'right',*/}
                    {/*    }}*/}
                    {/*    keepMounted*/}
                    {/*    transformOrigin={{*/}
                    {/*      vertical: 'top',*/}
                    {/*      horizontal: 'right',*/}
                    {/*    }}*/}
                    {/*    open={Boolean(anchorElUser)}*/}
                    {/*    onClose={handleCloseUserMenu}*/}
                    {/*  >*/}
                    {/*  </Menu>*/}
                    {/*</Box>*/}
                </Toolbar>
            </Container>
        </AppBar>
    );
};
export default ResponsiveAppBar;